import { Text } from '@linktr.ee/arbor/components/Text';
import React from 'react';
import { cn } from '../utils/twUtils';

interface HeaderProps {
  heading?: React.ReactNode;
  subHeading?: React.ReactNode;
  headingClasses?: string;
  subHeadingClasses?: string;
  className?: string;
}

export const Header: React.FC<HeaderProps> = ({
  heading,
  subHeading,
  headingClasses,
  subHeadingClasses,
  className,
}) => {
  if (!heading && !subHeading) {
    return null;
  }

  return (
    <header
      className={cn(
        'mb-2xl mx-auto my-6 flex w-full max-w-[760px] flex-col gap-2 px-6 text-center lg:gap-3 lg:px-0',
        className
      )}
    >
      {heading && (
        <Text
          as="h1"
          variant="display-small-extrabold"
          className={cn('text-black [text-wrap:balance]', headingClasses)}
        >
          {heading}
        </Text>
      )}
      {subHeading && (
        <Text
          as="div"
          variant="body-medium-regular"
          className={cn(
            'text-center text-secondary [text-wrap:balance] pt-md',
            subHeadingClasses
          )}
        >
          {subHeading}
        </Text>
      )}
    </header>
  );
};
